import FlycoService from "../../services/flyco.service";

const state = {
    flycoUserInfo: [],
    flycoUserInfos: []
};

const mutations = {
    set_flyco_info_list(state, payload) {
        state.flycoUserInfos = payload
    },
    set_flyco_info(state, payload) {
        state.flycoUserInfo = payload;
    }
};

const actions = {
    async getFlycoInfos({commit}) {
        const flyco = await FlycoService.getFlycoInfosService();
        commit("set_flyco_info_list", flyco);
        return flyco;
    },
    async getFlycoInfo({commit}, payload) {
        const flyco = await FlycoService.getFlycoInfoService(payload)
        commit("set_flyco_info", flyco);
        return flyco;
    },
    async AddFlycoInfo({dispatch}, payload) {
        const flyco = await FlycoService.AddFlycoInfoService(payload);
        dispatch("getFlycoInfos");
        return flyco;
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
